import * as React from "react";
import "./MultipleImagesSelect.css";

import { Dialog, Button, Intent, Spinner } from "@blueprintjs/core";
import { ALLOWED_FILE_TYPES, combinePdf, FileForPdf } from "../../QuestionUtils/PDFTools";

interface MultipleImagesSelectProps {
    onSetDocumentType: (doctype: string) => void;
    uploadPdf: (newVal: string) => void;
}
interface GenericDocumentWithExpiryInputState {
    isImagesModalOpen: boolean;
    isRemoveImageModalOpen: boolean;
    imageIndexToRemove: number | null;
    images: FileForPdf[];
    isPreparingPDF: boolean;
}

export class MultipleImagesSelect extends React.Component<MultipleImagesSelectProps, GenericDocumentWithExpiryInputState> {
    constructor(props: MultipleImagesSelectProps) {
        super(props);
        this.state = {
            isImagesModalOpen: false,
            isRemoveImageModalOpen: false,
            imageIndexToRemove: null,
            images: [],
            isPreparingPDF: false
        };
    }

    makePdf() {
        // append parent input to PDF doc Type
        this.setState({ isPreparingPDF: true });
        this.props.onSetDocumentType("PDF");

        setTimeout(() => {
            this.buildPdf();
        }, 0);
    }

    async buildPdf() {
        const newPdf = await combinePdf(this.state.images);
        this.props.uploadPdf(newPdf);
        this.setState({ isImagesModalOpen: false, isPreparingPDF: false });
    }

    handlePhotoChange(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.files === null || event.target.files.length === 0) {
            return;
        }
        let type = null;
        switch (event.target.files[0].type) {
            case "application/pdf":
            case "image/png":
            case "image/jpg":
            case "image/jpeg":
                type = event.target.files[0].type.split("/")[1];
                break;
            default:
        }
        if (type === null) {
            alert("cant upload video file");
            return;
        }
        const newFile: FileForPdf = {
            blob: event.target.files[0],
            fileName: event.target.files[0].name,
            type: type as ALLOWED_FILE_TYPES
        };
        this.setState({
            images: [...this.state.images, newFile]
        });
    }

    onUploadImagesModal(isOpen: boolean) {
        this.setState({ isImagesModalOpen: isOpen });
    }

    openRemoveImageDialog(): JSX.Element {
        return (
            <Dialog
                isOpen={true}
                isCloseButtonShown={false}
                title="Remove image"
                canOutsideClickClose={false}
                canEscapeKeyClose={false}
                className={"SubSectionLinkComponent__dialog"}
            >
                <div className="bp3-dialog-body">
                    Are you sure you want to remove this image?
                </div>
                <div className="bp3-dialog-footer">
                    <div className="bp3-dialog-footer-actions">
                        <Button
                            intent={Intent.PRIMARY}
                            onClick={() => this.removeImage()}
                            text="Yes"
                        />
                    </div>
                </div>
            </Dialog>
        );
    }

    removeImage() {
        if (this.state.imageIndexToRemove === null) {
            return;
        }
        let imagesArray = this.state.images;
        imagesArray.splice(this.state.imageIndexToRemove, 1);
        this.setState({
            images: imagesArray,
            isRemoveImageModalOpen: false
        });
    }

    render() {
        return (
            <div className="MultipleImagesSelect__root">
                {this.state.isImagesModalOpen ?
                    <Dialog
                        isOpen={true}
                        isCloseButtonShown={true}
                        title="Upload Images"
                        canOutsideClickClose={false}
                        canEscapeKeyClose={false}
                        className={"MultipleImagesSelect__dialog"}
                        onClose={() => this.onUploadImagesModal(false)}
                    >
                        <div className="bp3-dialog-body">
                            <div className="MultipleImagesSelect__imagesContainer">
                                {this.state.images.map((image, index) => {
                                    return (
                                        <div className="MultipleImagesSelect__imagePreview" key={index}>
                                            {
                                                image.type === "pdf" ? <span className="pdfUploadPreview" /> :
                                                    <img
                                                        src={URL.createObjectURL(image.blob)}
                                                    />
                                            }
                                            <div className="imagePreviewFileName">
                                                <span>{image.fileName}</span>
                                            </div>
                                            <div className="MultipleImagesSelect__imagePreview__actions">
                                                <span>{index + 1}</span>
                                                <i
                                                    className="fa fa-trash-o"
                                                    aria-hidden="true"
                                                    onClick={() => this.setState({
                                                        isRemoveImageModalOpen: true,
                                                        imageIndexToRemove: index
                                                    })}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="bp3-dialog-footer">
                            <div className={"MultipleImagesSelect__actions"}>
                                <label className="MultipleImagesSelect__customFileUpload">
                                    <input
                                        type="file"
                                        style={{ display: "none" }}
                                        onChange={(e) => this.handlePhotoChange(e)}
                                        accept="image/*;capture=camera"
                                        capture={true}
                                    />
                                    {this.state.images.length === 0 ? "Add file" : "Add another"}
                                </label>
                                <div className="MultipleImagesSelect__buildPdfBtnContainer">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-sm"
                                        disabled={this.state.images.length === 0}
                                        onClick={() => this.makePdf()}
                                    >
                                        Done
                                    </button>
                                    {this.state.isPreparingPDF ?
                                        <Spinner
                                            className="MultipleImagesSelect__preparingPdfLoader bp3-small"
                                            intent={Intent.PRIMARY}
                                        /> : null
                                    }
                                </div>

                            </div>
                        </div>
                    </Dialog>
                    :
                    <button
                        type="submit"
                        className="btn btn-primary btn-sm"
                        style={{ width: "150px" }}
                        onClick={() => this.onUploadImagesModal(true)}
                    >
                        Upload images
                    </button>
                }
                {this.state.isRemoveImageModalOpen ? this.openRemoveImageDialog() : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/widgets/MultipleImagesSelect.tsx